import React from "react";
import { ArrowRight, Phone } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function ProductFinderCTA() {
  return <section data-section-id="52622" id="sizin-değişiminiz-başlasın" className="dark bg-background text-foreground w-full">
      <div className="relative w-full bg-secondary/30 py-24 px-4 sm:px-8 overflow-hidden">
        {}
        <div className="absolute inset-0 opacity-10 pointer-events-none">
          <svg className="h-full w-full" viewBox="0 0 100 100" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 100 L100 0 L100 100 Z" fill="currentColor" className="text-primary" />
            <circle cx="20" cy="20" r="15" fill="currentColor" className="text-primary" />
            <circle cx="80" cy="80" r="10" fill="currentColor" className="text-primary" />
            <rect x="40" y="40" width="20" height="20" transform="rotate(45 50 50)" fill="currentColor" className="text-primary" />
          </svg>
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-primary/10 to-transparent" />
        </div>

        <div className="relative z-10 max-w-4xl mx-auto text-center space-y-8">
          <h2 className="text-4xl md:text-5xl font-serif text-foreground tracking-wider drop-shadow-md">
            Sıradaki Değişim Sizin Olsun.
          </h2>
          
          <p className="text-lg md:text-xl text-foreground/80 max-w-2xl mx-auto leading-relaxed font-sans font-light">
            Kayseri'nin kalbinde, modern teknoloji ve estetik dokunuşların buluştuğu kliniğimizde, size özel bir gülüş tasarımı deneyimi sunuyoruz. Hayalinizdeki gülüş için değişime bugün başlayın.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground/90 rounded-sm px-10 py-7 text-lg font-medium shadow-2xl transition-transform hover:scale-105 border-none">
              <Link to="/ContactPage">Randevu oluşturun</Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}